/**
 * Config shim for the CDN bundle. Resolved via Vite alias so the bundle does not depend on app config.
 * mount() can override brand via options.
 */
export const brand = 'mcom';
// Fulfillment/locator copy (embed has no app config)
const fulfillmentConfig = {
  BRAND: 'mcom',
  PRODUCT_SDD_FLAG: 'product sdd flag',
  SHIP_IT: 'ShipIt',
  PICK_UP: 'Pickup',
  EMAILED_24_HRS: 'Emailed within 24 hours',
  PARCEL_SHIPPING: 'Parcel Shipping',
  FURNITURE_SHIPPING: 'Furniture Shipping',
  FURNITURE_DELIVERY: 'Furniture delivery',
  PARCEL_DELIVERY: 'Parcel delivery',
  DELIVER: 'Deliver',
  SHIP: 'Ship',
  FREE_DELIVERY: 'Free delivery',
  FREE_SHIPPING: 'Free shipping',
  NA_PICKUP: 'Not available for pickup',
  SELECT_SIZE_COLOR_MESSAGE: 'Select a size and/or color to view shipping and in-store availability.',
  PICK_UP_AT_STORE: 'Pick up at store',
  FEW_LEFT: 'Just a few left!',
  LOW_STOCK: 'Low stock',
  PICK_UP_AT_STORE_MSG: 'Pick up at store. Check your local store if you want it sooner.',
  BAG_SHIP_ZIPCODE_CHANGE_COMPLETE: 'bag ship zipcode change complete',
  CONTINUE: 'Continue',
  CHANGE_STORE: 'Change Store',
  FIND_STORE: 'Find a store near you',
  PICK_UP_AT: 'Pickup at',
  NA_PICKUP_STORE: 'Not available for pickup at this store',
  ENTER_YOUR: 'Enter your',
  ZIP_CODE: 'zip code',
  SEE_DELIVERY_AVAILABILTY: 'to see delivery availability.',
  CHANGE_ZIP_CODE: 'Change Zip Code',
  NEW_ZIP_CODE: 'The new zipcode is',
  CHANGE_ZIP_CODE_BUTTON: 'Change zipcode button',
  NOT_AVAILABLE_FOR_SHIPPING: 'Not available for shipping',
  ZIPCODE_INVALID_MESSAGE: 'Please enter a valid zip code',
  ZIPCODE_INVALID_5DIGIT_MESSAGE: 'Please enter 5 digit valid zip code',
  ZIPCODE_UNDELIVERABLE_MESSAGE: 'Your items cannot be shipped to this zip code. Please try an alternate zip code.',
  APPLY: 'Apply',
  SHIP_ZIPCODE_CHANGE_START: 'ship zipcode change start',
  SHIP_ZIPCODE_CHANGE_COMPLETE: 'ship zipcode change complete',
  CHECK_YOUR_LABEL: 'Check your',
  LOCAL_STORE_LABEL: 'local store',
  SOONER_MESSAGE: 'if you want it sooner.',
  NEW_STORE_LABEL: 'The new store is',
  NEW_STORE_MESSAGE: 'Change Store Button',
};
const locatorConfig = {
  PRICE_VARIATION_TEXT: '*PLEASE NOTE: Samples, prices and promotions may vary in stores.',
  INVENTORY_DISCLAIMER: 'Some samples listed as "available" may actually be represented in-store by another item from the same collection. Our associates will be happy to help you with additional color options and configurations. Because our inventory is always changing, stock status and sample availability cannot be guaranteed.',
  DISPLAY_ITEM_NOTICE: 'This item is on display at the following stores. Style and color may vary.*',
  RUG_STORE_HEADING: 'Macy\'s stores with rug departments within {{ resultsDisplayed }} miles',
  SEARCH_BUTTON: 'Go',
  AVAILABILITY_TEXT: 'Available in',
  STORE_HOURS: 'Store Hours',
  TODAY: 'Today:',
  TOMORROW: 'Tomorrow:',
  CURBSIDE_HOURS: 'Curbside Hours',
  MY_STORE: 'My Store',
  SET_MY_STORE: 'Set As My Store',
  COLOR: 'Color:',
  ITEMS_UNAVAILABILITY_TEXT: 'Your items are not available at:',
};
export const config = {
  brand,
  ...fulfillmentConfig,
  ...locatorConfig,
};
// Re-export so `import { X } from 'config'` works
const allConfig = { ...fulfillmentConfig, ...locatorConfig };
export const {
  PRODUCT_SDD_FLAG, BAG_SHIP_ZIPCODE_CHANGE_COMPLETE, ZIPCODE_INVALID_MESSAGE, ZIPCODE_INVALID_5DIGIT_MESSAGE,
  ZIPCODE_UNDELIVERABLE_MESSAGE, APPLY, SHIP_ZIPCODE_CHANGE_START, SHIP_ZIPCODE_CHANGE_COMPLETE,
  BRAND, SHIP_IT, PICK_UP, EMAILED_24_HRS, FURNITURE_SHIPPING, FURNITURE_DELIVERY, PARCEL_DELIVERY, FREE_DELIVERY,
  FREE_SHIPPING, DELIVER, SHIP, NA_PICKUP, SELECT_SIZE_COLOR_MESSAGE, PICK_UP_AT_STORE, FEW_LEFT, LOW_STOCK,
  PICK_UP_AT_STORE_MSG, CONTINUE, CHANGE_STORE, FIND_STORE, PICK_UP_AT, NA_PICKUP_STORE, ENTER_YOUR, ZIP_CODE,
  SEE_DELIVERY_AVAILABILTY, CHANGE_ZIP_CODE, NEW_ZIP_CODE, CHANGE_ZIP_CODE_BUTTON, NOT_AVAILABLE_FOR_SHIPPING,
  CHECK_YOUR_LABEL, LOCAL_STORE_LABEL, SOONER_MESSAGE, NEW_STORE_LABEL, NEW_STORE_MESSAGE, PARCEL_SHIPPING,
  PRICE_VARIATION_TEXT, INVENTORY_DISCLAIMER, DISPLAY_ITEM_NOTICE, RUG_STORE_HEADING, SEARCH_BUTTON,
  AVAILABILITY_TEXT, STORE_HOURS, TODAY, TOMORROW, CURBSIDE_HOURS, MY_STORE, SET_MY_STORE, COLOR, ITEMS_UNAVAILABILITY_TEXT,
} = allConfig;
